<template>
  <div>
    <div class="item-line">活动计划信息</div>
    <div class="budgetBox bodyBox">
      <!-- lr0025 -->
      <a-form-model ref="activityForm" class="UniformCss" :inline="true" :label-col="{ span: 8 }">
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="活动计划编码">
              <a-input v-model="data.planCode" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="活动名称" class="act-item widthHuo" :label-col="{span:3}">
              <a-input v-model="data.actName" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="发布时间" class="act-item">
              <a-input v-model="data.releaseTime" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="预算类型" class="act-item">
              <a-input v-model="data.budgetTypeName" :disabled="disabled" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-model-item label="生效时间" class="act-item">
              <a-date-picker v-model="data.planStartTime" type="date" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="失效时间" class="act-item">
              <a-date-picker v-model="data.planEndTime" type="date" disabled />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="类型" class="act-item">
              <a-input :value="data.type == 0 ? '大区' : '总部'" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="一级来源" class="act-item">
              <a-input v-model="data.oneLevelName" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="二级来源" class="act-item">
              <a-input v-model="data.twoLevelName" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="三级来源" class="act-item">
              <a-input v-model="data.threeLevelName" :disabled="disabled" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="四级来源" class="act-item">
              <a-input v-model="data.fourLevelName" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="五级来源" class="act-item">
              <a-input v-model="data.fiveLevelName" :disabled="disabled" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col v-if="data.strainsCarName" :span="24">
            <a-form-model-item label="执行车系" class="act-item" :label-col="{span:2}">
              <el-tooltip class="item" effect="dark" content="点击查看" placement="top-start">
                <a-input v-model="data.strainsCarName" readonly @click.native="onShowCarSeries" />
              </el-tooltip>
            </a-form-model-item>
          </a-col>
          <a-col v-else :span="24">
            <a-form-model-item label="执行车系" class="act-item" :label-col="{span:2}">
              <a-input v-model="emptyText" disabled />
            </a-form-model-item>
          </a-col> -->
        <!-- </a-row>
        <a-row> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="经销商" class="act-item">
              <a-input v-model="data.dealerName" :disabled="disabled" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="12">
            <a-form-model-item label="市场活动来源" class="act-item" :label-col="{span:4}">
              <a-input v-model="selectedOrgText" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="费用额度(元)" class="act-item">
              <a-input v-model="formattedFeeLimit" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="核销比例(%)" class="act-item">
              <a-input v-model="data.writeRate" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="执行频次" class="act-item">
              <a-input v-model="data.executeFreq" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-model-item label="集客目标" class="act-item">
              <a-input v-model="data.customerTarget" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="订单目标" class="act-item">
              <a-input v-model="data.orderTarget" :disabled="disabled" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="执行数量" class="act-item">
              <a-input v-model="data.executeNum" :disabled="disabled" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col v-if="!specialBudget" :span="6">
            <a-form-model-item class="act-item">
              <span slot="label">
                剩余执行频次
                <el-tooltip class="item" effect="dark" content="剩余执行频次=活动执行频次-已提报活动之和" placement="top-start">
                  <i class="el-icon-info" style="font-size: 12px;color: #606266" />
                </el-tooltip>
              </span>
              <a-input v-model="data.remainFreq" :disabled="disabled" />
            </a-form-model-item>
          </a-col> -->
        </a-row>
        <a-row>
          <a-col :span="12" style="height: auto">
            <a-form-model-item label="其他说明" class="width100Px" :label-col="{span:4}">
              <a-input v-model="data.remarks" style="width: 100%" :disabled="disabled" type="textarea" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" style="height: auto">
            <a-form-model-item label="核销规则" class="width100Px" :label-col="{span:4}">
              <a-input v-model="data.writeOffRules" style="width: 100%" :disabled="disabled" type="textarea" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" style="height: auto">
            <a-form-model-item label="核销材料说明" class="width100Px" :label-col="{span:4}">
              <a-input v-model="data.writeOffMaterial" style="width: 100%" :disabled="disabled" type="textarea" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" style="height: auto">
            <a-form-model-item label="核销其他说明" class="width100Px" :label-col="{span:4}">
              <a-input v-model="data.writeOffOther" style="width: 100%" :disabled="disabled" type="textarea" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <el-dialog title="执行车系" :visible.sync="showCarSeries" width="40%">
      <vxe-table
        ref="xTable"
        border
        class="mytable-scrollbar"
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        style="margin-top: 10px"
        :max-height="$store.state.app.height - 350 < 185 ? 185 : $store.state.app.height - 350"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="carStrainList"
      >
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column title="品系" field="strains" align="center" />
        <vxe-column title="车系" field="carSeries" align="center" />
      </vxe-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCarSeries = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { toThousandNumFilter } from '@/filters/index.js'
export default {
  name: 'ActivityInformation',
  props: ['data', 'disabled', 'specialBudget'],
  data() {
    return {
      emptyText: '无',
      carStrainList: [],
      showCarSeries: false
    }
  },
  computed: {
    formattedFeeLimit() {
      return toThousandNumFilter(this.data.feeLimit)
    },
    selectedOrgText() {
      return this.data.oneLevelName + '/' + this.data.twoLevelName + '/' + this.data.threeLevelName
    }
  },
  methods: {
    onShowCarSeries() {
      // 使用逗号分割字符串
      const stringArray = this.data.strainsCarName.split(',')
      // 创建一个数组来存放对象
      const objectArray = []
      // 遍历分割后的字符串数组，并将每个元素转换为对象
      stringArray.forEach(function(item) {
        var parts = item.split('-') // 使用短横线分割每个元素
        if (parts.length === 2) {
          var obj = {
            strains: parts[0],
            carSeries: parts[1]
          }
          objectArray.push(obj)
        }
      })
      this.carStrainList = objectArray
      this.showCarSeries = true
    }
  }
}
</script>
<style lang="less" scoped>
.item-line {
  padding: 0px 20px;
  width: 100%;
  margin: 0;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.width100Px {
  .a-form-model-item__content {
    width: 80%;
  }
}
/deep/ .ant-form-item {
  display: flex;
}
/deep/ .ant-form-item-control-wrapper {
  width: 100%;
}
.widthHuo{
  ::v-deep .ant-form-item-label{
    width:100px !important
  }
}
</style>
